// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__o7LtC","badgePulse":"NotificationBadge_badgePulse__sH678","badgeBounce":"NotificationBadge_badgeBounce__leDgH"};